import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5a4 4 0 0 1 7.45 -2m-2.55 6h-7","key":"svg-0"}]]

/**
 * IconCurrencyPound
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktcG91bmQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDE4LjVhNiA2IDAgMCAxIC01IDBhNiA2IDAgMCAwIC01IC41YTMgMyAwIDAgMCAyIC0yLjV2LTcuNWE0IDQgMCAwIDEgNy40NSAtMm0tMi41NSA2aC03IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/currency-pound
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyPound = createReactComponent('outline', 'currency-pound', 'CurrencyPound', __iconNode);

export default IconCurrencyPound;